import React from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';

import New from './New';
import Details from './Details';
import Overview from './Overview';

const Inventory = props => {
  const paths = {
    details: `${props.match.path}/:id`,
    new: `${props.match.path}/new`,
  };

  return (
    <Switch>
      <Route exact path={paths.new} render={routerProps => <New {...props} {...routerProps} />} />
      <Route exact path={paths.details} render={routerProps => <Details {...routerProps} />} />
      <Route render={routerProps => <Overview {...routerProps} />} />
    </Switch>
  );
};

export default withRouter(Inventory);
